import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Dashboard } from './attendance.types';

@Component({
  selector: 'app-attendance-summary', standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './attendance-summary.component.html',
  styleUrls: ['./attendance-common.css', './attendance-summary.component.css'],
})
export class AttendanceSummaryComponent {
  @Input({required:true}) dashboard!: Dashboard;
  @Input() showSpinner=false;
  @Input() reasonOpen=false;
  @Input() finalizeOpen=false;
  @Input() editingLocked=false;
  @Input() adding=false;
  @Input() refreshInProgress=false;
  @Input() finalizationBusy=false;
  @Input() refreshIntervalSeconds=60;
  @Output() dateChange = new EventEmitter<string>();
  @Output() refresh = new EventEmitter<void>();

  dayLabel(day: string): string {
    return new Intl.DateTimeFormat('ja-JP', {year:'numeric',month:'long',day:'numeric',weekday:'short',timeZone:'Asia/Tokyo'}).format(new Date(day+'T00:00:00+09:00'));
  }
  historyTime(value: string): string { return value.replace('T',' ').slice(0,19); }
  remaining(attended: number, required: number): number { return Math.max(0, required - attended); }
}
